import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as auth_actions from 'data/auth/actions';


class LogoutMenuItem extends Component {

  logout = (e) => {
    setTimeout(this.props.actions.logout, 0);
  }

  render () {
    return (
      <div onClick={this.logout} >
        <span>Logga ut</span>
        </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}
const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...auth_actions }, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatch)(LogoutMenuItem)

  



// WEBPACK FOOTER //
// ./src/components/Auth/LogoutMenuItem.jsx